import { yup } from '@guiker/yup-util'

export const listingIdNested = yup.object({
  listingId: yup.string().required(),
})

export type ListingIdNested = yup.InferType<typeof listingIdNested>
